import {
  mlCardIconMockData,
  mlCardImageMockData,
} from '@/components/molecules';

export const orCardsListMockData = {
  cards: [
    mlCardImageMockData,
    mlCardImageMockData,
    mlCardImageMockData,
    mlCardIconMockData,
  ],
};
